module.exports = __webpack_public_path__ + "static/media/default-avatar.1b3cbcc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default-avatar.png
// module id = 79
// module chunks = 0